import { render } from "./NaturalStoneWallCopingFlat.vue?vue&type=template&id=45e539d0"
import script from "./NaturalStoneWallCopingFlat.vue?vue&type=script&lang=js"
export * from "./NaturalStoneWallCopingFlat.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/projects/rde/resources/vueapps/quotation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__